import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=1ddb3c0d&scoped=true&"
import script from "./Sessions.vue?vue&type=script&lang=js&"
export * from "./Sessions.vue?vue&type=script&lang=js&"
import style0 from "./Sessions.vue?vue&type=style&index=0&id=1ddb3c0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb3c0d",
  null
  
)

export default component.exports